import React from "react";
import {FormControlLabel, FormLabel, Radio, RadioGroup} from "@mui/material";
import {SelectField} from "@atttomyx/react-components";
import {forms, objects, strings} from "@atttomyx/shared-utils";
import {themes} from "@atttomyx/shared-constants";
import {RANKS_REQUIRED, TYPE_ADMIN, TYPE_INVENTOR, TYPE_INVESTOR} from "../../constants";
import "./userSettingsForm.css";

const UserSettingsForm = (props) => {
    const { data, onChange : onSync, settingsProps } = props;
    const { admin } = settingsProps;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.theme);

        onSync(modified);
    };

    return <div className="user-settings-form">
        <div className="option">
            <FormLabel id="theme">Theme</FormLabel>
            <RadioGroup row={true} aria-labelledby="theme"
                        onChange={(event) => onChange("theme", event.target.value)}>
                <FormControlLabel
                    value={themes.LIGHT}
                    label="Light"
                    control={<Radio checked={data.theme === themes.LIGHT} color="primary"/>}
                />
                <FormControlLabel
                    value={themes.DARK}
                    label="Dark"
                    control={<Radio checked={data.theme === themes.DARK} color="primary"/>}
                />
            </RadioGroup>
        </div>
        {admin ?
            <div className="option">
                <FormLabel id="mode">Mode</FormLabel>
                <RadioGroup row={true} aria-labelledby="mode"
                            onChange={(event) => onChange("mode", event.target.value)}>
                    <FormControlLabel
                        value={TYPE_ADMIN}
                        label="Admin"
                        control={<Radio checked={data.mode === TYPE_ADMIN} color="primary"/>}
                    />
                    <FormControlLabel
                        value={TYPE_INVESTOR}
                        label="Investor"
                        control={<Radio checked={data.mode === TYPE_INVESTOR} color="primary"/>}
                    />
                    <FormControlLabel
                        value={TYPE_INVENTOR}
                        label="Inventor"
                        control={<Radio checked={data.mode === TYPE_INVENTOR} color="primary"/>}
                    />
                </RadioGroup>
            </div> : null}
        {admin && data.mode === TYPE_INVENTOR ?
            <div className="field top-margin">
                <SelectField
                    required={true}
                    label="Rank"
                    value={forms.sanitizeValue(data.rank)}
                    onChange={(value) => onChange("rank", value)}
                    options={RANKS_REQUIRED}
                />
            </div> : null}
    </div>
}

export default UserSettingsForm;
